import { client } from 'utils/client'
import { intercept } from 'utils/http'
import { APIResponse } from 'types/api'

export const useApi = () => {
  const wrap = async <TResponse extends APIResponse>(
    request: Promise<Response>
  ): Promise<TResponse> => {
    const res = await request
    return intercept<TResponse>(res)
  }

  return {
    get: <TResponse extends APIResponse = APIResponse>(
      url: string,
      params?: Record<string, unknown>,
      signal?: AbortSignal
    ) => wrap<TResponse>(client.get(url, params, signal)),

    post: <TResponse extends APIResponse = APIResponse, TRequest = unknown>(
      url: string,
      body?: TRequest,
      signal?: AbortSignal
    ) => wrap<TResponse>(client.post(url, body, signal)),

    put: <TResponse extends APIResponse = APIResponse, TRequest = unknown>(
      url: string,
      body?: TRequest,
      signal?: AbortSignal
    ) => wrap<TResponse>(client.put(url, body, signal)),

    patch: <TResponse extends APIResponse = APIResponse, TRequest = unknown>(
      url: string,
      body?: TRequest,
      signal?: AbortSignal
    ) => wrap<TResponse>(client.patch(url, body, signal)),

    delete: <TResponse extends APIResponse = APIResponse>(
      url: string,
      params?: Record<string, unknown>,
      signal?: AbortSignal
    ) => wrap<TResponse>(client.delete(url, params, signal)),

    download: (url: string, params?: Record<string, unknown>) => client.download(url, params),
  }
}
